// Entry point for the build script in your package.json
// 
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form');

  if (!form) {
    return;
  }

  const submitButton = form.querySelector('input[type="submit"]');

  // When the form is submitted, we disable the submit button
  form.addEventListener('submit', () => {
    submitButton.disabled = true;
  })
});
